import React, { useState } from "react";
import { Grid,Select } from "semantic-ui-react";
import DatePicker from "react-date-picker";
import { useStateValue } from "../../StateProvider";
import "./styles/stepOne.css";
const locationOptions = [
  
  {
    key: "oc",
    value: "oc",
    text: "Orange County",
  },
];

const StepOne = () => {
  const [{date,time}, dispatch] = useStateValue();
  //to be dynmatic later available times...
  const [times] = useState([
    { key: "0900AM", value: "0900", text: "09:00AM" },
    { key: "0930AM", value: "0930", text: "09:30AM" },
    { key: "1000PM", value: "1300", text: "01:00PM" },
    { key: "0100AM", value: "0100", text: "01:00AM" },
  ]);


const setSelectedDate = (date)=>{

  dispatch({
    type:"ADD_SELECTED_DATE",
    date,
  })
}

const setSelectedTime = (time)=>{

  dispatch({
    type:"ADD_SELECTED_TIME",
    time,
  })
}

  return (

    <Grid  stackable columns='equal' centered style={{   gap:"1rem",marginTop: "auto",
     marginBottom: "auto",}}>
  
    <Grid.Column textAlign='center' width={4}>
      <DatePicker
        className="ui selection dropdown"
        clearIcon={null}
        onChange={(date) =>{setSelectedDate(date)}}
        
        value={date}
      />
      </Grid.Column>
      <Grid.Column textAlign='center' width={4}>
      <Select
        onChange={(e, { value }) => {
          setSelectedTime(value)
        }}
        value={time}
        options={times}
        placeholder="Available times"
      />
      </Grid.Column>
      <Grid.Column textAlign='center' width={4}>
      <Select disabled placeholder="Orange County" options={locationOptions} />
      </Grid.Column>
   
    </Grid>
  );
};

export default StepOne;
